module.exports = __webpack_public_path__ + "img/gis-map.2233b7f7.svg";